export default __webpack_public_path__ + "static/media/Flaticon.d7754f77.svg";